import { mapState } from 'vuex';
export default {
  name: 'IsFMFields',
  props: {
    propObject: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      panel: null
      // doorId: '',
      // floor: '',
      // room: '',
      // lcl: {}
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])
  },
  mounted() {
    // console.log('this.propObject',this.propObject)
    // this.doorId = this.propObject.doorId
    // this.floor = this.propObject.floor
    // this.room = this.propObject.room
  },
  methods: {}
};